export function SquareSvgIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 501.42 501.42"
      fill="currentColor"
      {...props}
    >
      <title>Square</title>
      <path d="M501.42,83.79v333.84c0,46.27-37.5,83.79-83.79,83.79H83.79c-46.28,0-83.79-37.5-83.79-83.79V83.79C0,37.51,37.52,0,83.79,0h333.84c46.29,0,83.79,37.5,83.79,83.79h0ZM410.22,117.64c0-14.61-11.85-26.45-26.45-26.45H117.62c-14.61,0-26.45,11.84-26.45,26.45v266.19c0,14.61,11.84,26.45,26.45,26.45h266.17c14.61,0,26.45-11.85,26.45-26.45V117.64h-.02ZM182.31,197.59c0-8.43,6.79-15.26,15.17-15.26h106.4c8.39,0,15.17,6.84,15.17,15.26v106.24c0,8.43-6.75,15.26-15.17,15.26h-106.4c-8.39,0-15.17-6.84-15.17-15.26v-106.24Z" />
    </svg>
  )
}

/**
 * Nav variant of the Square mark. Line-style to sit with the lucide icons: a
 * stroked rounded square (matching their 24-viewBox / stroke-width 2) with a
 * small filled rounded square at the centre — recognisably the Square logo, but
 * light enough not to read as a solid block. Inherits the nav colour via
 * currentColor.
 */
export function SquareNavIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinejoin="round"
      {...props}
    >
      <title>Square</title>
      <rect x="2" y="2" width="20" height="20" rx="3.5" />
      <rect
        x="8.75"
        y="8.75"
        width="6.5"
        height="6.5"
        rx="1"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  )
}
